// Caches how many events the current user has, so the /events skeleton can
// render the right number of placeholder rows/cards on first paint instead
// of a generic guess. Written after every successful fetch of the events
// list; read synchronously at component setup time.
//
// Thin, page-specific wrapper around the generic cache — see
// composables/useSkeletonCountCache.js and docs/skeleton_count_caching.md.
import { getCachedSkeletonCount, setCachedSkeletonCount } from './useSkeletonCountCache'

const KEY = 'events_count'
const DEFAULT_COUNT = 1

export function getCachedEventsCount() {
  return getCachedSkeletonCount(KEY, DEFAULT_COUNT)
}

export function setCachedEventsCount(count) {
  setCachedSkeletonCount(KEY, count)
}
